import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

const ContentAccordionSection = ({
  // eslint-disable-next-line react/prop-types
  title,
  // eslint-disable-next-line react/prop-types
  children
}) => {
  let contentAccordionContents = [];
  const sectionTitle = (
    <>
      {title && (
        <div className="sui-pb-4">
          <Typography variant="h2" weight="display" height="snug" color="primary" uppercase>{title}</Typography>
        </div>
      )}
    </>
  );

  return (
    <div className="sui-flex sui-flex-col sui-mt-2 sui-gap-1">
      {sectionTitle}
      {children}
    </div>
  );
};

export { ContentAccordionSection };
